import { useAuthStore } from "@/auth/stores/auth";
import { getCurrentAccount } from "@/shared/utils/sessionStorage.utils";
import type { RouteLocationNormalized } from "vue-router";

export const hasPlanAccess = (route: Pick<RouteLocationNormalized, "matched">) => {
  const plan = useAuthStore().getAccountPlan || getCurrentAccount()?.plan || null;
  const accessPlans = route.matched.reduce<string[]>((acc, r) => {
    const routePlans = Array.isArray(r.meta.plan) ? (r.meta.plan as string[]) : [];
    return [...acc, ...routePlans];
  }, []);

  if (Array.isArray(accessPlans) && accessPlans.length > 0) {
    const hasPlan = accessPlans.includes(plan);
    return hasPlan;
  }
  return true;
};
